import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTestimonialById,
  clearSelectedTestimonial,
  createTestimonial,
  updateTestimonial,
} from "../redux/testimonialsSlice";
import {
  Container,
  Typography,
  Paper,
  TextField,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
  Stack,
} from "@mui/material";

const TestimonialEditorPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const loading = useSelector((state) => state.testimonials.loading);
  const [form, setForm] = useState({
    fullName: "",
    designation: "",
    content: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        try {
          const testimonial = await dispatch(fetchTestimonialById(id)).unwrap();
          setForm({
            fullName: testimonial.fullName || "",
            designation: testimonial.designation || "",
            content: testimonial.content || "",
          });
        } catch (err) {
          console.error("Yorum alınamadı:", err);
        }
      } else {
        setForm({ fullName: "", designation: "", content: "" });
      }
    };

    fetchData();
    return () => dispatch(clearSelectedTestimonial());
  }, [id, dispatch]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await dispatch(
          updateTestimonial({ id, updatedTestimonial: form })
        ).unwrap();
        setSnackbar({
          open: true,
          message: "Yorum güncellendi!",
          severity: "success",
        });
      } else {
        await dispatch(createTestimonial(form)).unwrap();
        setSnackbar({
          open: true,
          message: "Yorum oluşturuldu!",
          severity: "success",
        });
      }
      setTimeout(() => navigate("/admin/testimonials"), 1500);
    } catch (err) {
      console.error("İşlem başarısız:", err);
      setSnackbar({
        open: true,
        message: "İşlem başarısız",
        severity: "error",
      });
    }
  };

  if (loading || (id && form.fullName === "")) {
    return (
      <Stack alignItems="center" mt={8}>
        <CircularProgress color="primary" />
        <Typography mt={2}>Yükleniyor...</Typography>
      </Stack>
    );
  }

  return (
    <Container maxWidth="md" sx={{ my: 5 }}>
      <Typography variant="h5" fontWeight="bold" mb={3}>
        {id ? "Yorumu Düzenle" : "Yeni Yorum Ekle"}
      </Typography>

      <Paper sx={{ p: 4 }}>
        <form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            {/* Ad Soyad */}
            <TextField
              label="Ad Soyad"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
              required
              fullWidth
            />

            {/* Ünvan */}
            <TextField
              label="Ünvan"
              name="designation"
              value={form.designation}
              onChange={handleChange}
              fullWidth
            />

            {/* Yorum */}
            <TextField
              label="Yorum"
              name="content"
              value={form.content}
              onChange={handleChange}
              required
              fullWidth
              multiline
              rows={5}
            />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ alignSelf: "flex-start" }}
            >
              Gönder
            </Button>
          </Stack>
        </form>
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default TestimonialEditorPage;
